import { Component, OnInit } from '@angular/core';
import { CustomService } from '../custom.service';
import { environment } from '../../environments/environment';
import { ActivatedRoute } from '@angular/router';
import { SeoService } from '../seo.service';

// Test code
import { Observable } from 'rxjs';
import { delay, map, tap } from 'rxjs/operators';
import { fadeIn, fadeOut } from '../animations/fade-animations';
import { trigger } from '@angular/animations';
const RESPONSE_DELAY = 800;
// end

@Component({
    selector: 'app-products',
    templateUrl: './products.component.html',
    animations: [
        trigger('fadeOut', fadeOut()),
        trigger('fadeIn', fadeIn(':enter'))
    ],
    styleUrls: ['./products.component.css']
})
export class ProductsComponent implements OnInit {
    env : any;
    products : any ;
    Banner : any;
    availableProducts : boolean = false;
    availableBanner : boolean = false;
    CategoryId : any;
    availableCategoryProducts : boolean = false;

    ghosts = [];
    CertificateGhosts = new Array(0);
    TradeFair = new Array(0);

    productlist$ : Observable<any[]>;
    seoArray = [];

    constructor(
        public customservice : CustomService,
        public router : ActivatedRoute,
        public seoService: SeoService
    ) {
        this.env = environment;

        this.router.data.subscribe(
            (data :any)=>{
                this.CategoryId = data.CategoryId;
            }
        )

        if(this.CategoryId){
            this.getCategorywiseProducts(this.CategoryId);
        }else{
            this.getAllProducts();
        }


    }
    ngOnInit() {

    }

    getAllProducts(){

        this.ghosts = new Array(9);
        this.productlist$ = this.customservice.getProducts().pipe(
            delay(RESPONSE_DELAY),
            map(getproductinfo),
            tap((data) => {
                this.ghosts = [];
                this.customservice.getPageDetail(8).subscribe(
                    (data : any)=>{
                        this.seoArray.push(
                            {name: 'description', content:data.PageInfo.results[0].MetaDesc},
                            {name: 'keywords', content: data.PageInfo.results[0].Keywords}
                        )
                        this.seoService.setTitle(data.PageInfo.results[0].MetaTitle);
                        this.seoService.addMetaTags(this.seoArray);

                        if(data.PageInfo.results.length > 0){
                            this.Banner = data.PageInfo.results[0].PageBanner;
                            this.availableBanner = true;
                        }
                    },(error)=>{
                        console.log(error)
                    }
                )

                if(data.products.results.length > 0){
                    this.products = data.products.results;
                    this.availableProducts = true;
                }
            })
        )

        // this.customservice.getProducts().subscribe(
        //     (data : any)=>{
        //         if(data.products.results.length > 0){
        //             this.products = data.products.results;
        //             this.availableProducts = true;
        //         }
        //     },(error)=>{
        //         console.log(error)
        //     }
        // )
        // this.customservice.getPageDetail(8).subscribe(
        //     (data : any)=>{
        //         if(data.PageInfo.results.length > 0){
        //             this.Banner = data.PageInfo.results[0].PageBanner;
        //             this.availableBanner = true;
        //         }
        //     },(error)=>{
        //         console.log(error)
        //     }
        // )
    }

    getCategorywiseProducts(CategoryId){
        this.ghosts = new Array(9);
        this.productlist$ = this.customservice.getProductsbyCategoryId(CategoryId).pipe(
            delay(RESPONSE_DELAY),
            map(getproductinfo),
            tap((data) => {
                this.ghosts = [];

                this.seoArray.push(
                    {name: 'description', content:data.categoryinfo[0].MetaDesc},
                    {name: 'keywords', content: data.categoryinfo[0].Keywords}
                )
                
                this.seoService.setTitle(data.categoryinfo[0].MetaTitle);
                this.seoService.addMetaTags(this.seoArray);

                if(data.catproducts.length > 0){
                    this.products = data.catproducts;
                    this.availableCategoryProducts = true;
                }
                if(data.categoryinfo[0].CategoryBanner){
                    this.Banner = data.categoryinfo[0].CategoryBanner;
                    this.availableBanner = true;
                }
            })
        )

        // this.customservice.getProductsbyCategoryId(CategoryId).subscribe(
        //     (data :any)=>{
        //         if(data.catproducts.length > 0){
        //             this.products = data.catproducts;
        //             this.availableCategoryProducts = true;
        //         }
        //         if(data.categoryinfo[0].CategoryBanner){
        //             this.Banner = data.categoryinfo[0].CategoryBanner;
        //             this.availableBanner = true;
        //         }
        //
        //     },(error :any)=>{
        //         console.log("Oops,there is some error.please try again");
        //     }
        // )
    }

}

function getproductinfo(data){
    return data;
}
